import type React from 'react';

import { Select } from '@frontend/components';

import type { SelectorValue } from '../types';
import type { DateRangeValue, DateRangeType } from '../types';
import DateRangeInput from './DateRangePicker';

const DEFAULT_DATE_FILTER_VALUE = { startDate: null, endDate: null };

export const DATE_RANGE_PRESETS = {
  NONE: 'n/a',
  TODAY: 'today',
  LAST_SEVEN_DAYS: 'last_seven_days',
  LAST_THIRTY_DAYS: 'last_thirty_days',
  LAST_SIX_MONTHS: 'last_six_months',
  CUSTOM_RANGE: 'custom_range',
};

export const DATE_RANGE_PRESET_LABELS = {
  [DATE_RANGE_PRESETS.NONE]: 'N/A',
  [DATE_RANGE_PRESETS.TODAY]: 'Today',
  [DATE_RANGE_PRESETS.LAST_SEVEN_DAYS]: 'Last 7 days',
  [DATE_RANGE_PRESETS.LAST_THIRTY_DAYS]: 'Last 30 days',
  [DATE_RANGE_PRESETS.LAST_SIX_MONTHS]: 'Last 6 months',
  [DATE_RANGE_PRESETS.CUSTOM_RANGE]: 'Custom Range',
};

export const getTimeRangeFromFilters = (
  dateRangeValue: DateRangeType,
): DateRangeValue | string | null => {
  if (!dateRangeValue) {
    return null;
  } else if ('label' in dateRangeValue && 'value' in dateRangeValue) {
    return dateRangeValue.value;
  } else {
    return dateRangeValue || null;
  }
};

type DateRangeSelectorPropTypes = {
  value?: DateRangeValue | SelectorValue<string> | null;
  onChange: (arg0: DateRangeValue | SelectorValue<string> | null) => void;
};

const DateRangeSelector: React.FC<DateRangeSelectorPropTypes> = ({
  value,
  onChange,
}) => {
  if (
    !value ||
    ('value' in value && value.value !== DATE_RANGE_PRESETS.CUSTOM_RANGE)
  ) {
    return (
      <Select
        id="dateRange"
        placeholder="Select date range"
        options={Object.keys(DATE_RANGE_PRESET_LABELS).map((key) => ({
          label: DATE_RANGE_PRESET_LABELS[key],
          value: key,
        }))}
        isMulti={false}
        value={value}
        onChange={onChange}
        isClearable={false}
      />
    );
  } else {
    return (
      <DateRangeInput
        relationFilterValue={
          'value' in value && value.value === DATE_RANGE_PRESETS.CUSTOM_RANGE
            ? DEFAULT_DATE_FILTER_VALUE
            : value
        }
        onChange={(value: DateRangeValue) => {
          if (value.startDate === null && value.endDate === null) {
            onChange(null);
          } else {
            onChange(value);
          }
        }}
        style={{ flex: '1 1 auto' }}
      />
    );
  }
};

export default DateRangeSelector;
